import { computed, defineComponent, onMounted, ref } from 'vue';
import { Button, Input } from '@yellowcard/components-library-vue3';
import CurrencyBadge from '@/components/currency/CurrencyBadge.vue';
import CurrencyRate from '@/components/currency/CurrencyRate.vue';
import { numberFormat } from '@/utils/helpers';
import validator from 'validator';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { TransactTypes } from '@/types/transact';
import { useGeneralStore } from '@/store/modules/general';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
var BuySteps = TransactTypes.TransactSteps;
export default defineComponent({
    name: 'SellCryptoComponent',
    components: {
        Button,
        CurrencyBadge,
        CurrencyRate,
        Input,
    },
    emits: ['refresh'],
    setup() {
        const transactionsStore = useTransactionsStore();
        const generalStore = useGeneralStore();
        const { coinCurrencySelect } = storeToRefs(generalStore);
        const { selectedCrypto, selectedCurrency, selectedCryptoAmount, selectedCurrencyAmount, maxTransactionAmount, minTransactionAmount, rates, currentStep, } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { isLoggedIn, partnerId } = storeToRefs(authStore);
        const showCryptoInput = ref(false);
        const showCurrencyInput = ref(false);
        const currencyAmountValid = ref(false);
        const cryptoAmountValid = ref(false);
        const errorMessage = ref('');
        const cryptoPlaceholder = computed(() => {
            const countryMinMax = transactionsStore.getMinMax();
            return `max ${numberFormat(countryMinMax.max ?? 100, 4)}`;
        });
        const removeCharsFromNumber = (number) => number.replace(/[^0-9.]/g, '');
        const cryptoMinMaxCheck = (amount) => {
            const minMax = transactionsStore.getMinMax();
            if (!minMax) {
                errorMessage.value = 'Transaction limits not set';
                return;
            }
            errorMessage.value = '';
            if (!validator.isNumeric(amount)) {
                errorMessage.value = 'Enter a valid amount';
            }
            else if (Number(amount) < minMax.min) {
                errorMessage.value = `Please enter an amount greater than ${selectedCrypto.value.token} ${numberFormat(minMax.min, 6)}`;
            }
            else if (Number(amount) > minMax.max) {
                errorMessage.value = `Please enter an amount lower than ${selectedCrypto.value.token} ${numberFormat(minMax.max, 6)}`;
            }
        };
        const onAmountEntered = (value) => {
            const formattedValue = removeCharsFromNumber(value);
            const inputElement = document.getElementById('sell-crypto-coin-input');
            if (inputElement) {
                inputElement.value = formattedValue;
            }
            cryptoMinMaxCheck(formattedValue);
            selectedCryptoAmount.value.amount = Number(formattedValue);
            selectedCurrencyAmount.value.amount =
                transactionsStore.calculateFiatAmount(selectedCryptoAmount.value.amount);
        };
        onMounted(async () => {
            if (!rates.value.length) {
                rates.value = await transactionsStore.getRates();
                if (selectedCryptoAmount.value.amount) {
                    selectedCurrencyAmount.value.amount =
                        transactionsStore.calculateFiatAmount(selectedCryptoAmount.value.amount);
                }
            }
            if (selectedCryptoAmount.value.amount) {
                onAmountEntered(`${selectedCryptoAmount.value.amount}`);
            }
        });
        const onBadgeSelected = async (event) => {
            if (event.type === 'Currency') {
                coinCurrencySelect.value = 'Currency';
            }
            else {
                coinCurrencySelect.value = 'Coin';
            }
            currentStep.value = BuySteps.CURRENCY_COIN_SELECT;
        };
        const focusInput = () => {
            const inputElement = document.getElementById('sell-crypto-coin-input');
            if (inputElement) {
                if (selectedCryptoAmount.value.amount) {
                    inputElement.value = numberFormat(selectedCryptoAmount.value.amount, 8);
                }
                const eventType = 'onfocusin' in inputElement ? 'focusin' : 'focus';
                const event = new Event(eventType);
                inputElement?.focus();
                inputElement?.dispatchEvent(event);
            }
            else {
                console.log('Element not found');
            }
        };
        const focusFiatInput = () => {
            const inputElement = document.getElementById('sell-crypto-currency-input');
            if (inputElement) {
                if (selectedCurrencyAmount.value.amount) {
                    inputElement.value = numberFormat(selectedCurrencyAmount.value.amount, 2);
                }
                const eventType = 'onfocusin' in inputElement ? 'focusin' : 'focus';
                const event = new Event(eventType);
                inputElement?.focus();
                inputElement?.dispatchEvent(event);
            }
            else {
                console.log('Element not found');
            }
        };
        const toggleCurrencyInput = () => {
            showCurrencyInput.value = !showCurrencyInput.value;
        };
        const toggleCryptoInput = () => {
            showCryptoInput.value = !showCryptoInput.value;
        };
        const onKeyPress = () => {
            console.log();
        };
        const onSellButtonClicked = () => {
            trackEvent(MIXPANEL_EVENTS.SELL.SELL, {
                logged_in: isLoggedIn.value,
                partner: partnerId.value,
            });
            currentStep.value = TransactTypes.TransactSteps.BUY_2;
        };
        const onFiatAmountEntered = (value) => {
            const formattedValue = removeCharsFromNumber(value);
            const newCryptoAmount = transactionsStore.calculateCryptoAmount(Number(formattedValue));
            cryptoMinMaxCheck(newCryptoAmount.toString());
            selectedCurrencyAmount.value.amount = Number(formattedValue);
            selectedCryptoAmount.value.amount = Number(newCryptoAmount);
        };
        return {
            showCryptoInput,
            onBadgeSelected,
            currencyAmountValid,
            cryptoAmountValid,
            toggleCurrencyInput,
            toggleCryptoInput,
            showCurrencyInput,
            onKeyPress,
            selectedCrypto,
            selectedCurrency,
            selectedCryptoAmount,
            selectedCurrencyAmount,
            numberFormat,
            onAmountEntered,
            errorMessage,
            maxTransactionAmount,
            minTransactionAmount,
            onSellButtonClicked,
            focusInput,
            onFiatAmountEntered,
            focusFiatInput,
            cryptoPlaceholder,
        };
    },
});
